
<template>
    <as-modal title="Alert" @close="$emit('close', $event)" class="bankAlert">
          <p>Please select atleast one bank!</p>
          </as-modal>
</template>

<script>
    import AsModal from '../Ui/AsModal.vue'
    export default {
        name: "AlertBox",
        components: {
            AsModal,
        }
    }
</script>
<style lang="scss" scoped>
    .bankAlert {
        p {
            margin: 1em 0;
        }
        ul, li {
            list-style: square;
            list-style-position: inside;
        }
    }
</style>